<template>
  <b-tooltip
    :label="tooltip"
    :position="position"
    :delay="delay"
    :type="tooltipType || type"
    :multilined="multilined"
  >
    <b-button
      v-bind="$attrs"
      :type="type"
      :class="buttonClass"
      :style="buttonStyle"
      v-on="$listeners"
    />
  </b-tooltip>
</template>

<script>
export default {
  name: "ButtonTooltip",
  inheritAttrs: false,
  props: {
    tooltip: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: "is-top",
    },
    delay: {
      type: [Number, String],
      default: 0,
    },
    type: {
      type: String,
      default: "",
    },
    tooltipType: {
      type: String,
      default: "",
    },
    multilined: {
      type: Boolean,
      default: false,
    },
    buttonClass: {
      type: [String, Object, Array],
      default: "",
    },
    width: {
      type: [String, Number],
      default: "",
    },
    minWidth: {
      type: [String, Number],
      default: "",
    },
    maxWidth: {
      type: [String, Number],
      default: "",
    },
  },
  computed: {
    buttonStyle() {
      const style = {};

      if (this.width) {
        style.width = isNaN(this.width) ? this.width : `${this.width}px`;
      }
      if (this.minWidth) {
        style.minWidth = isNaN(this.minWidth)
          ? this.minWidth
          : `${this.minWidth}px`;
      }
      if (this.maxWidth) {
        style.maxWidth = isNaN(this.maxWidth)
          ? this.maxWidth
          : `${this.maxWidth}px`;
      }

      return style;
    },
  },
};
</script>

<style scoped>
.button {
  cursor: pointer;
  transition: all 0.2s ease;
}

.button:hover {
  transform: translateY(-1px);
}
</style>
